import './ProgressRing.css';

export interface ProgressRingProps {
  value: number;
  max: number;
  size?: number;
  label?: string;
}

/** W06/W03 — circular progress indicator ("42 / 120 months"). Malformed values clamp to [0,1]. */
export function ProgressRing({ value, max, size = 120, label }: ProgressRingProps) {
  const safeMax = Number.isFinite(max) && max > 0 ? max : 1;
  const safeValue = Number.isFinite(value) ? Math.min(Math.max(value, 0), safeMax) : 0;
  const ratio = safeValue / safeMax;
  const stroke = Math.max(8, Math.round(size / 12));
  const radius = (size - stroke) / 2;
  const circumference = 2 * Math.PI * radius;

  return (
    <div className="ring" style={{ width: size, height: size }} data-testid="progress-ring">
      <svg width={size} height={size} role="img" aria-label={label ?? `${Math.round(ratio * 100)}%`}>
        <circle cx={size / 2} cy={size / 2} r={radius} className="ring-track" strokeWidth={stroke} />
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          className="ring-value"
          strokeWidth={stroke}
          strokeDasharray={circumference}
          strokeDashoffset={circumference * (1 - ratio)}
          strokeLinecap="round"
          transform={`rotate(-90 ${size / 2} ${size / 2})`}
        />
      </svg>
      <div className="ring-center">
        <strong className="tabular">
          {safeValue}/{safeMax}
        </strong>
        {label && <span className="ring-label">{label}</span>}
      </div>
    </div>
  );
}
